/** @jsx h */
import getComponent from '../utils/get-component'
import { h } from 'preact'
import Icon from './icon'

export default getComponent(
  'link db pv2 mt1 pl3 f4 hover-bg-mid-gray',
  { active: false, tagName: 'a' },
  ({ active }, { icon, title }) => ({
    className: active ? 'green' : 'light-silver hover-moon-gray',
    children: (
      <div className='ml2 flex items-center'>
        <Icon className='f3' size='20' icon={icon} />
        <span className={icon ? 'pl3' : null}>{title}</span>
      </div>
    )
  })
)
